module.exports = __webpack_public_path__ + "img/ .66f268e6.png";